"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AI_APP_SIDEBAR_NODES = void 0;
const constants_1 = require("../constants");
const R = constants_1.AI_CONSOLE_ROLES;
/** AI 应用构建侧栏（与 `routes.ai` 第三项对应）。 */
exports.AI_APP_SIDEBAR_NODES = [
    {
        id: 'aiapp-knowledge',
        type: 'group',
        menuKey: 'knowledgeBase',
        msg: 'nav.aiApp.knowledgeBase',
        roles: R,
        children: [
            {
                id: 'aiapp-knowledge-leaf',
                menuKey: 'knowledgeBase',
                msg: 'nav.aiApp.knowledgeBase',
                path: '/llm/datasets',
                roles: R,
            },
        ],
    },
    {
        id: 'aiapp-build',
        type: 'group',
        menuKey: 'appBuild',
        msg: 'nav.aiApp.appBuild',
        roles: R,
        children: [
            {
                id: 'aiapp-build-leaf',
                menuKey: 'appBuild',
                msg: 'nav.aiApp.appBuild',
                path: '/llm/apps',
                roles: R,
            },
        ],
    },
    {
        id: 'aiapp-market',
        type: 'group',
        menuKey: 'appMarket',
        msg: 'nav.aiApp.appMarket',
        roles: R,
        children: [
            {
                id: 'aiapp-market-leaf',
                menuKey: 'appMarket',
                msg: 'nav.aiApp.appMarket',
                path: '/llm/explore/apps',
                roles: R,
            },
        ],
    },
];
